export default {
  setReport(state, {report, data}) {
    state[report].data = data
  },

  setFetching(state, {report, value}) {
    state[report].fetching = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/mutations.js